import { Button, HeadingLevel } from "@ariakit/react";
import { interactiveText } from "@indietabletop/appkit/common.css.ts";
import { lacquer } from "../../common/common.css.ts";
import { database } from "../../database.ts";
import { BuildStep, StandaloneBuildStep, WrapUpStep } from "./BuildStep.tsx";
import { GangActions } from "./GangActions.tsx";
import { GangModelsList } from "./GangModelsList.tsx";
import { GangHeader } from "./GangView.tsx";
import { buildMode, gang as gangCss } from "./style.css.ts";
import { useGangContext } from "./useGang.ts";

function InitialChaosModeStep() {
  const { gang } = useGangContext();

  return (
    <StandaloneBuildStep
      stepLabel="Step 1"
      heading="Gather your gits!"
      text="Roll up random gits, vehicles, and loadout with one click."
      button={
        <Button
          className={buildMode.button}
          onClick={() => {
            const { data } = gang.runChaosMode();
            void database.gangs.updateOne(data);
          }}
        >
          Roll them up
        </Button>
      }
    />
  );
}

function GenerateGangStep() {
  const { gang } = useGangContext();

  return (
    <BuildStep
      done
      stepLabel="Step 1"
      heading="Gather your gits!"
      text={
        <>
          <strong>Done!</strong> Continue to <em className={lacquer}>step 2</em>{" "}
          or{" "}
          <Button
            className={interactiveText}
            onClick={() => {
              const { data } = gang.runChaosMode();
              void database.gangs.updateOne(data);
            }}
          >
            roll again
          </Button>
          .
        </>
      }
    >
      <GangModelsList />
    </BuildStep>
  );
}

export function ChaosModeView() {
  const { gang } = useGangContext();
  const { models, mode } = gang;

  return (
    <div className={gangCss.container}>
      <GangHeader />

      <HeadingLevel>
        {mode.isDone ? (
          <>
            <GangModelsList />
            <GangActions />
          </>
        ) : models.length === 0 ? (
          <InitialChaosModeStep />
        ) : (
          <div className={buildMode.steps}>
            <GenerateGangStep />
            <WrapUpStep stepLabel="Step 2" />
          </div>
        )}
      </HeadingLevel>
    </div>
  );
}
